import { useEffect } from 'react';

import { toast } from '@motorway/mw-highway-code/pre-alpha';

import useSavedFiltersStore from 'Stores/SavedFiltersStore/SavedFiltersStore';

/**
 * Subscribes to the SavedFiltersStore error field and surfaces it as a toast.
 * Mirrors the v1 useStoreToast behaviour but uses the THC toast instead of
 * the legacy motorway-storybook-cra useToast.
 */
export const useSavedSearchStoreToast = (): void => {
	const clearError = useSavedFiltersStore((store) => store.clearError);

	useEffect(
		() =>
			useSavedFiltersStore.subscribe(
				(store) => store.error,
				(error) => {
					if (!error) return;
					const { intent, message } = error as { intent?: string; message: unknown };
					toast({
						content: `${message}`,
						variant: intent === 'warning' ? 'warning' : 'error',
					});
					clearError();
				},
			),
		[clearError],
	);
};
